// extracted by mini-css-extract-plugin
export default {"wrapper":"Copyrights_wrapper__KSJXa","rights":"Copyrights_rights__gIqwe"};